import { useEffect } from 'react';

export const PAGE_TITLES = {
  '/dashboard': 'Dashboard',
  '/integrations': 'Client Integrations',
  '/analytics': 'Analytics',
  '/users': 'User Management',
  '/documents': 'Documents',
  '/projects': 'Projects',
  '/settings': 'Settings',
  '/referrals': 'Referral Portal',
  '/closed-referrals': 'Referral Portal - Closed Referrals',
  '/carrier-engagement-dashboard': 'Carrier Engagement Dashboard',
};

/**
 * Custom hook to set the page title dynamically
 * @param {string} title - The page-specific title (e.g., "Login", "Integrations")
 */
export const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title ? `SmartLight - ${title}` : 'SmartLight';

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
